import Vue from 'vue';
import {
  baidutongji
} from '../package.json'

// 注入百度统计上报功能
Vue.prototype.$baidutongji = {
  push() {
    if ('_hmt' in window && window._hmt.push instanceof Function && arguments[0] instanceof Array) {
      try {
        window._hmt.push(arguments[0]); // 调用 SDK
      } catch (error) {
        console.log(error);
      }
    }
    if (process.env.NODE_ENV !== 'production') {
      // console.log(arguments[0]);
    }
  },
  trackevent() {
    if (arguments[0] instanceof Array) {
      const messages = ['_trackEvent'].concat(arguments[0]); // 添加埋点基础信息
      try {
        // 只有当埋入的数据只有三个时才追加用户信息
        if (window.vueApplication && messages.length === 3) {
          messages.push(window.vueApplication.$store.state.userinfo.name); // 添加用户信息
        }
      } catch (error) {
        console.log(error);
      }
      this.push(messages);
    }
  },
  trackpageview() {
    if (arguments[0] instanceof Array) {
      this.push(['_trackPageview'].concat(arguments[0])); // 添加埋点基础信息
    }
  }
};

export default {
  init() {
    if (process.env.NODE_ENV === 'production') {
      window._hmt = window._hmt || []; // 挂载到window上
      const hm = document.createElement('script');
      hm.src = `https://hm.baidu.com/hm.js?${baidutongji.key}`;
      const s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(hm, s);
    }
  },
  callback(data) {
    if (data instanceof Array) {
      Vue.prototype.$baidutongji.trackevent(data); // 上报事件分析数据
    }
  },
}